<template>
  <div class="login">
    <div class="top">
      <img src="../assets/img/logo.png" alt="" />
    </div>
    <div class="main-body">
      <div
        class="login-div"
        :style="{ height: missVerfiy ? '490px' : '440px' }"
      >
        <h1 class="title">至信链管理后台</h1>
        <p class="tip">至信辟金 共链未来</p>
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item prop="userName">
            <el-input
              v-model="form.userName"
              placeholder="请输入邮箱"
              prefix-icon="el-icon-message"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              @keyup.enter.native="onSubmit"
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </el-form-item>
          <div v-show="missVerfiy" class="input verification">
            <el-input
              placeholder="请输入验证码"
              type="text"
              v-model="verification"
            >
              <i slot="prefix">
                <img class="input_pre mima" src="../assets/verfiy.png" />
              </i>
            </el-input>
            <img @click="refreshCaptcha" :src="captcha" class="captcha" />
          </div>
          <el-form-item class="remember_pwd">
            <el-checkbox v-model="remember">记住密码</el-checkbox>
          </el-form-item>
          <el-button
            v-loading="logining"
            @click="onSubmit"
            type="primary"
            class="login-btn"
            >登录</el-button
          >
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode, baseURL } from '@/config'
import { interRoute, statisRoute, defaultRoute,operationDefaultRoute } from '@/config/menuroute.js'
import { resetRouter } from '@/router'
import {
  setStorageItem,
  getStorageItem,
  removeStorageItem,
  setCookie,
  getCookie,
  delCookie,
} from '@/utils'
import { sm3 } from '@/utils/sm3'

export default {
  name: 'Login',
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      if (reg.test(value)) {
        return callback()
      }
      return callback(new Error('邮箱格式不正确'))
    }
    return {
      permissionRoutes: [],
      form: {
        userName: '',
        password: '',
      },
      missVerfiy: false,
      verification: '',
      captcha: `${baseURL}/user/captcha?timestamp=${new Date().getTime()}`,
      remember: true,
      logining: false,
      rules: {
        userName: [{ required: true, validator: checkEmail, trigger: 'blur' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    if (getStorageItem('loginForm')) {
      this.form = JSON.parse(getStorageItem('loginForm'))
    }
    if (location.href.indexOf('#reloaded') > -1) {
      const _index = location.href.indexOf('reloaded')
      location.href = location.href.substring(0, _index - 1)
      location.reload()
    }
    // this.getLoginInfo()
  },
  methods: {
    refreshCaptcha() {
      if (this.refreshing) {
        return
      }
      this.captcha = `${baseURL}/user/captcha?timestamp=${new Date().getTime()}`
      console.log(this.captcha)
      this.refreshing = true
      setTimeout(() => {
        // 防止用户频繁刷新图片验证码，设置2s间隔
        this.refreshing = false
      }, 2000)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.logining = true
          if (this.remember) {
            setStorageItem('loginForm', JSON.stringify(this.form))
          } else {
            if (getStorageItem('loginForm')) {
              removeStorageItem('loginForm')
            }
          }
          const req = {
            email: this.form.userName,
            pwd: sm3(this.form.password),
          }
          if (this.verification) {
            req.verifyCode = this.verification
          }
          Api.user
            .login(req)
            .then((res) => {
              if (res.retCode === statusCode.SUCCESS) {
                setStorageItem('token', res.token)
                if (location.href.includes(window.managment_redirectUrl.admin)) {
                  // 测试环境
                  // setCookie(
                  //   'zxadmintoken',
                  //   encodeURIComponent(res.token),
                  //   '.zhixinblockchain.com'
                  // )
                  setCookie(
                    'zxadmintoken',
                    encodeURIComponent(res.token),
                    window.location.host
                  )
                } else {
                  // 本地
                  setCookie('zxadmintoken', encodeURIComponent(res.token)) // 兼容本地调试
                }
                this.$message({
                  showClose: true,
                  message: '登录成功',
                  type: 'success',
                  // duration: 500,
                })
                this.getLoginInfo()
                // this.$router.push({
                //   name: 'customerAuditList',
                // })
              } else {
                if (res.retCode === 8035 || res.retCode === 8036) {
                  this.missVerfiy = true
                  this.refreshCaptcha()
                  this.logining = false
                  if (res.retCode === 8035) {
                    this.$message({
                      showClose: true,
                      message: '请输入验证码',
                      type: 'error',
                    })
                    return
                  }
                }
                this.$message.closeAll()
                this.$message({
                  showClose: true,
                  message: res.retMsg,
                  type: 'error',
                })
              }
              this.logining = false
            })
            .catch(() => {
              this.logining = false
            })
        }
      })
    },
    getLoginInfo() {
      this.permissionRoutes = this.permissionRoutes.concat(defaultRoute).concat(operationDefaultRoute)
      // 判断是否已经登陆，检查token信息
      if (!getCookie('zxadmintoken')) {
        return
      }
      removeStorageItem('loginInfo')
      Api.user
        .getLoginInfo()
        .then((res) => {
          this.$message.closeAll()
          if (res.retCode === statusCode.SUCCESS) {
            setStorageItem('loginInfo', res.detail)
            // this.$store.commit('setRoleID', res.detail.roleID)
            // 运营人员3 不能查看数据统计信息


             // 临时修改 2021.3.23
            // res.detail.roleID  = 5

            if (
              res.detail.roleID == 1 ||
              res.detail.roleID == 2 ||
              res.detail.roleID == 4
            ) {
              resetRouter()
              // this.permissionRoutes = this.permissionRoutes.concat(statisRoute)
              this.permissionRoutes.splice(1, 0, ...statisRoute)
              // this.$router.addRoutes(statisRoute)
              // this.$router不是响应式的，所以手动将路由元注入路由对象
              // this.$router.options.routes.splice(3, 0, statisRoute[0])
              // this.$router.options.routes.concat(statisRoute)
            }

            // 进行路由的修改 超管1和 管理员2 才能看到内部人员列表
            if (res.detail.roleID == 1 || res.detail.roleID == 2) {
              resetRouter()
              // this.permissionRoutes = this.permissionRoutes.concat(interRoute)
              this.permissionRoutes.splice(2, 0, ...interRoute)
              // this.$router.addRoutes(interRoute)
              // this.$router不是响应式的，所以手动将路由元注入路由对象
              // this.$router.options.routes.concat(interRoute)
              // this.$router.options.routes.splice(4, 0, interRoute[0])
            }

            // 暂时所有的角色都可以看到运维角色v1.2.4    运维角色 查看运维中心 用户中心
            if(res.detail.roleID == 5){
              this.permissionRoutes = []
              this.permissionRoutes =  this.permissionRoutes.concat(operationDefaultRoute)
            }
            this.$store.commit('setPermissionRoutes', this.permissionRoutes)

             console.log("this.permissionRoutes",this.permissionRoutes[0])
            
             // 获取第一个作为默认路由,如果有孩子，将孩子作为首次进入的路由
             let firstRouterName = ''
             let firstRouterObj = this.permissionRoutes[0]
             firstRouterName = firstRouterObj.name
             if(firstRouterObj.children && firstRouterObj.children.length){
               firstRouterName = firstRouterObj.children[0].name
             }
             this.$nextTick(() => {
                this.$router.push({
                  name: firstRouterName
                })
             })
          } else {
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.login {
  .top {
    width: 100%;
    height: 60px;
    background-color: #152857;
    display: flex;
    align-items: center;
    img {
      margin-left: 50px;
    }
  }
  .main-body {
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../assets/img/bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .login-div {
      width: 460px;
      height: 410px;
      background-color: #ffffff;
      border-radius: 8px;
      .title {
        color: #3969bd;
        font-size: 32px;
        margin-top: 36px;
        text-align: center;
      }
      .tip {
        font-size: 20px;
        color: #3969bd;
        text-align: center;
        margin-top: 10px;
      }
      .el-form {
        width: 320px;
        margin-left: 70px;
        margin-top: 30px;
        /deep/ .el-input__inner {
          background-color: #f6f6f6;
          height: 50px;
        }
        .remember_pwd {
          text-align: right;
        }
        .verification {
          margin-top: -15px;
          margin-bottom: 15px;
        }
        .verification {
          text-align: left;
          cursor: pointer;
          .el-input {
            width: 60%;
          }
          .captcha {
            height: 40px;
            vertical-align: middle;
            margin-left: 10px;
          }
        }
        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 44px;
          border-radius: 8px;
          border: 1px solid rgb(204, 215, 233);
        }
        .input_pre {
          width: 18px;
          height: 21px;
          top: 16px;
          position: relative;
          left: 10px;
        }
        .login-btn {
          width: 100%;
          color: #ffffff;
          background: linear-gradient(to right, #3969bd 0%, #0041be 100%);
          height: 50px;
          font-size: 20px;
          // margin-top: 15px;
        }
      }
    }
  }
}
</style>
